import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import "./DarkMode.css";
import { ReactComponent as Moon } from "./Moon.svg";
import { ReactComponent as Sun } from "./Sun.svg";

const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const DarkMode = () => {
  const platform = localStorage.getItem("platform");
  const searchParams = new URLSearchParams(window.location.search);
  const isTelegram = searchParams.get("platform") === "telegram" || platform === "telegram";

  const setDarkMode = () => {
    document.querySelector("body").setAttribute("data-theme", "dark");
    if (!isTelegram) {
      const logoImg = document.querySelector(".logo img");
      if (logoImg) {
        logoImg.src = toAbsoluteUrl(
          `/image/${process.env.REACT_APP_IMAGE_PATH}/2a.png?15641555`
        );
      }
    }
    setCookie("selectedTheme", "dark", 365);
  };

  const setLightMode = () => {
    document.querySelector("body").setAttribute("data-theme", "light");
    if (!isTelegram) {
      const logoImg = document.querySelector(".logo img");
      if (logoImg) {
        logoImg.src = toAbsoluteUrl(
          `/image/${process.env.REACT_APP_IMAGE_PATH}/2.png?15641555`
        );
      }
    }
    setCookie("selectedTheme", "light", 365);
  };

  const selectedTheme = getCookie("selectedTheme");

  if (selectedTheme === "dark" || (isTelegram && !selectedTheme)) {
    setDarkMode();
  }

  const toggleTheme = (e) => {
    const myEvent = new Event("setTheme");
    window.dispatchEvent(myEvent);
    if (e.target.checked) setDarkMode();
    else setLightMode();
  };

  return (
    <div className="dark_mode">
      <input
        className="dark_mode_input"
        type="checkbox"
        id="darkmode-toggle"
        onChange={toggleTheme}
        defaultChecked={selectedTheme === "dark" || (isTelegram && !selectedTheme)}
      />
      <label className="dark_mode_label" htmlFor="darkmode-toggle">
        <Sun />
        <Moon />
      </label>
    </div>
  );
};

export default DarkMode;
